import React, { useEffect, useRef, useState } from "react";
import { Flex } from "./style";
import { Box } from "../../assets/globalStyles/styledColoredBoxWithInfo";
import SwitchButton from "../../components/switchButton";
import { Field } from "redux-form";
import TextField from "../../components/textField";
import returnNumber from "../../lib/returnNumber";
import { Confirm } from "../../components/confirm";
import { withRouter } from "react-router-dom";
import { WARNING_SINGLE_BUTTON_TEXT } from "../../constants/otherTexts";
import { accountingCodeLength } from "../../constants/maxLenghtAtrribute";
import { isEmpty } from "lodash";
import { StyledIcon } from "../../assets/globalStyles/styledIcon";

const SingleAccountingCode = props => {
  const [expand, setExpand] = useState(false);
  const [confirm, setConfirm] = useState({ show: false, message: "" });

  const {
    input,
    history,
    disabled,
    formErrors,
    change,
    title,
    infoText
  } = props;

  useEffect(() => {
    if (input && input.value) {
      if (!isEmpty(input.value)) {
        setExpand(true);
      } else {
        setExpand(false);
      }
    }
  }, [input]);
  const toggleSwitch = () => {
    if (expand) {
      change(null);
    }
    setExpand(!expand);
  };

  const closeConfirm = () => {
    setConfirm({ show: false, message: "" });
  };
  const showConfirm = infoMessage => {
    setConfirm({ show: true, message: infoMessage });
  };

  return (
    <React.Fragment>
      <Confirm
        show={confirm.show}
        rejectHandler={() => closeConfirm()}
        close={() => closeConfirm()}
        content={{
          type: "info",
          message: confirm.message,
          rejectButtonText: WARNING_SINGLE_BUTTON_TEXT,
          icon: "icon mapsa-i-letter"
        }}
      />
      <Box>
        <Flex>
          <Flex>
            <span className="title">
              {title || "الگو کد حسابداری سرفصل‌حساب‌ها"}
            </span>
            <StyledIcon
              onClick={() => showConfirm(infoText)}
              mr={8}
              fontSize={22}
            >
              <i className="icon mapsa-info" />
            </StyledIcon>
          </Flex>
          <div className="switch-wrapper">
            <SwitchButton
              input={{ value: expand, onChange: toggleSwitch }}
              disable={disabled}
            />
          </div>
        </Flex>
        {expand && (
          <Flex align="start" marginBottom="3.6" marginTop="2">
            <div className="text-input-wrapper">
              <Field
                component={TextField}
                name={`${input.name}.code`}
                inputMode="decimal"
                label="کد حسابداری"
                meta={{
                  error: formErrors && formErrors.length > 0 ? formErrors : null
                }}
                normalize={number => returnNumber(number)}
                maxLength={accountingCodeLength}
              />
            </div>
          </Flex>
        )}
      </Box>
    </React.Fragment>
  );
};
export default withRouter(SingleAccountingCode);
